import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PostDetails  from './components/pages/PostDetails';
import Events from './components/pages/Events';
import EventDetails from './components/pages/EventDetails';
import QuestionsPage from './components/pages/QuestionsPage';
import AboutStuttering from './components/pages/AboutStuttering';
import About from './components/pages/About';
import Membership from "./components/pages/Membership";
import Support from './components/pages/Support';
import LoginRedirect from './components/LoginRedirect';
import './App.css';



function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/about' component={About} />
          <Route path='/posts/:slug' component={PostDetails} />
          <Route path='/events/:slug' component={EventDetails} />
          <Route path='/events' component={Events} />
          <Route path='/faq' component={QuestionsPage} />
          <Route path='/stuttering' component={AboutStuttering} />
          <Route path="/membership" component={Membership} />
          <Route path="/support" component={Support} /> 
          <Route path="/login" component={LoginRedirect} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
